import { useCreateEvent } from '@/features/events/hooks/useCreateEvent';
import { EventType } from '@/features/events/types/EventType';
import { ParametersTrendGraph } from '@/features/ocr/components/ParametersTrendGraph';
import { parameterStatusUtils } from '@/features/ocr/types/ParameterData';
import { LoadingOverlay } from '@/features/shared/components/Loaders';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetSingleParam } from '../hooks/useGetSingleParam';
const ParameterInfoPage = () => {
  const query = new URLSearchParams(useLocation().search);
  const parameter = query.get('parameter');
  const graph = query.get('graph');
  const { sendEvent } = useCreateEvent()

  useEffect(() => {
      void sendEvent({
        event: EventType.PAGE_VIEW,
        sub_category: "parameter_info_page",
        event_metadata: { parameter, with_graph: graph},
      })
    }, [])

  const { data: parameterData } = useGetSingleParam(parameter!);


  const ranges = parameterData?.map((param) => param.range);

  if (!ranges || ranges.length === 0) {
    return <LoadingOverlay/>;
  }

  const averageRange = {
    min: Number(
      (ranges.reduce((acc, curr) => acc + curr.min, 0) / ranges.length).toFixed(
        2,
      ),
    ),
    max: Number(
      (ranges.reduce((acc, curr) => acc + curr.max, 0) / ranges.length).toFixed(
        2,
      ),
    ),
  };

  if (!parameter) {
    return <LoadingOverlay/>;
  }
  
  return (
    <div className='w-full h-full'>
      <div className='font-bold text-[22px] leading-[33px]'>
        {parameterStatusUtils.getNameForId(parameter.toUpperCase())}
      </div>
      <div>
        {parameterStatusUtils.getGeneralNotionForId(parameter.toUpperCase())}
      </div>

      {graph && parameterData && parameterData.length > 1 && (
        <div className='h-2/3 w-full pt-8'>
          <ParametersTrendGraph
            values={parameterData}
            range={{ min: averageRange.min, max: averageRange.max }}
          />
        </div>
      )}
    </div>
  );
};

export default ParameterInfoPage;
